module.exports = __webpack_public_path__ + "static/media/31JFA6.fd3ac044.jpg";